import {useContext, useRef, useState, useEffect} from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import {StyledFormWrapper, StyledFormBody, StyledForm} from '../../helpers/base-form';
import {DoubleRow, DoubleRowItem, Field, Input, Label, LabelTip} from '../../helpers/base-field';
import {Button, ButtonColor, ButtonSize} from '../button/button';
import {shapingApiUrl} from '../../shared/util';
import axios from 'axios';
import {InitializeParamsContext} from '../../store/context/context';

const RedirectLink = ({text, styles, isLink}) => {
    return (
        <>
            {isLink ? (
                <a
                    target="_blank"
                    href="/upload/production-orders/send-order-info.png"
                    className="form-check-orders__show error-margin"
                    style={{...styles, fontWeight: 'bold'}}
                    //
                >
                    {text}
                </a>
            ) : (
                <p
                    className="form-check-orders__show error-margin"
                    style={{...styles}}
                    //
                >
                    {text}
                </p>
            )}
        </>
    );
};

const OrderForm = ({onFindOrder, setHideForm, setShowModal, setOrderNumber, setUserName}) => {
    const [taskNumber, setTaskNumber] = useState('');
    const [error, setError] = useState(null);
    const orderId = useContext(InitializeParamsContext).orderId;

    const post = (apiUrl, config) => {
        axios
            .post(apiUrl, null, config)
            .then((response) => {
                setHideForm(true);
                onFindOrder(response.data.data);
                setTimeout(() => setShowModal(true), 20000);
                setOrderNumber(taskNumber);
                setUserName(response.data.data.user.names);
            })
            .catch((error) => {
                setError(
                    <RedirectLink
                        isLink={false}
                        text={error?.response?.data?.message || 'Извините, произошла ошибка при поиске заказа'}
                        styles={{color: 'red', margin: '5px 0'}}
                    />
                );
            });
    };

    useEffect(() => {
        if (orderId) {
            const URL = '/track-production-orders/add/';
            const apiUrl = shapingApiUrl(URL, [], []);
            const config = {
                params: {
                    taskNumber: orderId,
                    recaptchaToken: 'get',
                },
            };

            post(apiUrl, config);
        }
    });

    const checkErrorInputNumber = (value) => {
        if (!value || value.length <= 0) {
            setError(<RedirectLink text="Обязательно для заполнения" styles={{color: 'red'}} />);
            return true;
        }
        if (isNaN(Number(value))) {
            setError(<RedirectLink text="Допустимы только цифры" styles={{color: 'red'}} />);
            return true;
        } else if (value.length > 6) {
            setError(
                <>
                    <RedirectLink
                        isLink={false}
                        text={'Неверный номер заказа'}
                        styles={{color: 'red', margin: '5px 0'}}
                    />
                    <RedirectLink
                        isLink
                        text="Как узнать номер ПЗ?"
                        styles={{
                            textDecoration: 'underline',
                            color: 'blue',
                        }}
                    />
                </>
            );
            return true;
        }
        if (value.length < 6) {
            setError(
                <>
                    <RedirectLink isLink={false} text={'Укажите 6 цифр'} styles={{color: 'red', margin: '5px 0'}} />
                    <RedirectLink
                        isLink
                        text="Как узнать номер ПЗ?"
                        styles={{
                            textDecoration: 'underline',
                            color: 'blue',
                        }}
                    />
                </>
            );
            return true;
        }
        return false;
    };

    const recaptchaRef = useRef();
    const submitHandler = async (event) => {
        event.preventDefault();

        const token = await recaptchaRef.current.execute();

        if (checkErrorInputNumber(taskNumber)) return false;

        const URL = '/track-production-orders/add/';
        const apiUrl = shapingApiUrl(URL, [], []);
        const config = {
            params: {
                taskNumber: taskNumber,
                recaptchaToken: token,
            },
        };

        post(apiUrl, config);
    };

    return (
        <StyledFormWrapper>
            <StyledForm>
                <StyledFormBody as={'form'} onSubmit={submitHandler}>
                    <Field>{error}</Field>
                    <Field>
                        <Label htmlFor={'task-number'}>
                            Номер задания
                            <LabelTip>
                                <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7 .875a6.125 6.125 0 1 0 0 12.25A6.125 6.125 0 0 0 7 .876Zm0 11.21a5.087 5.087 0 1 1 .002-10.173A5.087 5.087 0 0 1 7 12.086Z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M6.344 4.594a.656.656 0 1 0 1.312 0 .656.656 0 0 0-1.312 0Zm.984 1.531h-.656a.11.11 0 0 0-.11.11v3.718c0 .06.05.11.11.11h.656c.06 0 .11-.05.11-.11V6.234a.11.11 0 0 0-.11-.109Z"
                                        fill="currentColor"
                                    />
                                </svg>
                                <span className="icon-info-help">
                                    6 цифр, без нолей в начале номера ПЗ. Например, 100898.
                                    <a
                                        target="_blank"
                                        href="/upload/production-orders/send-order-info.png"
                                        className="form-check-orders__show"
                                        style={{
                                            textDecoration: 'underline',
                                            color: 'blue',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        <br />
                                        Как узнать номер ПЗ?
                                    </a>
                                </span>
                            </LabelTip>
                        </Label>
                        <Input
                            id={'task-number'}
                            type={'text'}
                            name={'task-number'}
                            value={taskNumber}
                            required
                            title={'Введите номер задания'}
                            onChange={(event) => setTaskNumber(event.target.value)}
                        />
                    </Field>
                    <DoubleRow>
                        <DoubleRowItem>
                            <Button type={'submit'} size={ButtonSize.LARGE} color={ButtonColor.DARK_BLUE}>
                                ДАЛЕЕ
                            </Button>
                        </DoubleRowItem>
                    </DoubleRow>
                    <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey="6LcQqM4ZAAAAALUMwoKOo7TrVRrqd_CQ8lw-Bf_2" />
                </StyledFormBody>
            </StyledForm>
        </StyledFormWrapper>
    );
};

export {OrderForm};
